import { Breakpoint } from '@philips-internal/oswald-ui-constants';
import { getBreakpoint } from './index.js';
function isXSmallResolution() {
    return Breakpoint.XSM === getBreakpoint();
}
export default isXSmallResolution;
//# sourceMappingURL=is-xsmall-resolution.js.map